import React, { Fragment, useContext } from 'react'
import Image from 'react-bootstrap/Image'
import hallayallh from 'assets/images/landingpage/HY_Logo.webp'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Separator from 'components/Separator'
import { JazeelContext } from '../../../../utils/JazeelContext'
import Badge from 'react-bootstrap/Badge'
export default function Brands() {
  const { userData } = useContext(JazeelContext)

  return (
    <Fragment>
      {userData.all_brands.length <= 0 ? (
        <p className="text-center text-danger">
          You haven't joined and brand until now
        </p>
      ) : (
        <Fragment>
          {userData.all_brands.map(brand => (
            <Fragment key={brand.name}>
              <Row className="pt-3">
                {/*<Col xs={3}>*/}
                {/*  <Image src={hallayallh} fluid />*/}
                {/*</Col>*/}
                <Col xs={12}>
                  <Badge variant="success float-right" pill>
                    + {brand.earned_points} Points
                  </Badge>
                  <h5>{brand.name}</h5>
                  <p className="text-muted">{brand.description}</p>
                </Col>
              </Row>
              <Separator marginTop="0.5em" />
            </Fragment>
          ))}
        </Fragment>
      )}
    </Fragment>
  )
}
